'use client'

import { motion, AnimatePresence } from 'framer-motion'
import { LinkItem } from '../config/links'
import { LinkCard } from './LinkCard'
import { useSeasonalTheme } from '../hooks/useSeasonalTheme'

interface LinkGridProps {
  links: LinkItem[]
}

export function LinkGrid({ links }: LinkGridProps) {
  const { theme } = useSeasonalTheme()
  const enabledLinks = links.filter(l => l.enabled !== false)

  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4, delay: 0.4 }}
      className="flex-1 px-4 py-6 pb-20 overflow-y-auto"
    >
      <AnimatePresence mode="popLayout">
        <motion.div
          key={theme.id}
          layout
          className="grid grid-cols-2 gap-3 sm:grid-cols-3 max-w-2xl mx-auto w-full"
        >
          {enabledLinks.map((link, index) => (
            <LinkCard key={link.id} link={link} index={index} />
          ))}
        </motion.div>
      </AnimatePresence>
    </motion.section>
  )
}